import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReservationStep3Form from './reservationstep3Form.component';
import {createOrder} from '../../actions/payment.actions';

class ReservationStep3 extends Component {
    
    getSeats = () => {
        let seats = "";
        let results = this.props.selectedSeats.concat(this.props.selectedCouch);
        
        const length = results.length;
        results.map((seat, i) => {
            const newI = i + 1;
            if (newI < length) {
                seats += seat.id_seat + ', ';
            } else {
                seats += seat.id_seat
            }
        });
        
        return seats;
    }

    getTicketsInfo = () => {
        let ticketsInfo = {
            tickets: "",
            total: 0.00,
            clientCategoryIds: ""
        } 
         
        this.props.storedTickets.map((fee,i) => {
            if(fee.quantity > 0) {
                for (let i=0; i < fee.quantity; i++){
                    if (fee.one4two == "1"){
                        // this need to be duplicated because the AppSmart api needs then in this format
                        ticketsInfo.tickets += fee.id_fee + "," + fee.id_fee + ",";
                        ticketsInfo.clientCategoryIds += fee.id_client_category + "," + fee.id_client_category + ",";
                    } else { 
                        ticketsInfo.tickets += fee.id_fee + ",";
                        ticketsInfo.clientCategoryIds += fee.id_client_category + ",";
                    }
                }         
                ticketsInfo.total += parseFloat(fee.totalPrice);
            }
        });
        ticketsInfo.tickets = ticketsInfo.tickets.slice(0, ticketsInfo.tickets.length - 1);
        ticketsInfo.clientCategoryIds = ticketsInfo.clientCategoryIds.slice(0, ticketsInfo.clientCategoryIds.length - 1);

        return ticketsInfo;
    }

    handleSubmit = (data) => {
        const ticketsInfo = this.getTicketsInfo();
        const payload = {
            schedule_id: this.props.movieDetails.scheduleId,
            seat_count: this.props.selectedSeats.length + this.props.selectedCouch.length, 
            status_id: 0,
            uid: this.props.movieDetails.userId,
            details: "<p>mai multe detalii despre locuri: <b>H/28</b> (student)</p>",
            details_json: {
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                phone: data.phone,
                cnp: "",
                address: data.address,
                id_cinema: this.props.id_cinema,
                id_event: this.props.movieDetails.eventId,
                seats: this.getSeats(), 
                fee_ids: ticketsInfo.tickets,
                client_category_ids: ticketsInfo.clientCategoryIds,
                total: ticketsInfo.total,
                id_phone_type: "3",
                booking_code: "",
                selected_products: "",
                selected_quantities: "",
                selected_prices: "",
                selected_types: "",
                menu_options: "",
            }
        }
        this.props.createOrder(payload);
    }

    render() {
        return(
            <div className="container">
                <ReservationStep3Form onSubmit={this.handleSubmit} />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    storedTickets: state.movieTheaters.selectedTickets,
    selectedSeats: state.movieTheaters.selectedSeats,
    selectedCouch: state.movieTheaters.selectedCouch,
    id_cinema: state.movieTheaters.hallConfiguration.room.id_cinema,
    movieDetails: state.filters.movieDetailsFilters
});

export default withRouter(connect(mapStateToProps, {createOrder})(ReservationStep3));


// WEBPACK FOOTER //
// ./src/SHARED/components/modalreservation/reservationstep3.component.js